import React from "react";
import { TurnrModalContainer, TurnrModalContent } from "~/components/modals/TurnrModal.jsx";
import FormEntryPoint from "~/components/entityAction/form/FormEntryPoint";
import { SkeletonLoaderWrapper } from "~/components/loading/skeletons/SkeletonLoaderWrapper.jsx";
import LineDivider from "rylak-common/src/components/divider/LineDivider";
import { UserAvatarFullInfo } from "~/components/userAvatar/UserAvatar.jsx";

function ReportModalUserContent({ user, title }) {
    return (
        <TurnrModalContent>
            {title && (
                <div
                    className={"muted"}
                    style={{
                        fontSize: "11px",
                        marginBottom: "10px",
                        marginLeft: "48px",
                    }}
                >
                    {title}
                </div>
            )}
            <UserAvatarFullInfo user={user} />
        </TurnrModalContent>
    );
}

export function WarehouseReportInfoModalContent({ appProps, warehouseReport, warehouseReportSummary, loading }) {
    return (
        <TurnrModalContainer>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {warehouseReport?.user && <ReportModalUserContent user={warehouseReport?.user} title={"Reporter"} />}
                {warehouseReport?.reviewedBy && <ReportModalUserContent user={warehouseReport?.reviewedBy} title={"Reviewer"} />}
            </div>
            <LineDivider />
            <TurnrModalContent>
                <div style={{ position: "relative" }}>
                    <SkeletonLoaderWrapper loadingMinHeight={"400px"} loadingMinWidth={"600px"} loading={loading}>
                        {warehouseReportSummary && <FormEntryPoint appProps={appProps} readOnly={true} formParameters={warehouseReportSummary?.formParameters} formValues={{}} />}
                    </SkeletonLoaderWrapper>
                </div>
            </TurnrModalContent>
        </TurnrModalContainer>
    );
}
